var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.document)?_c('div',{staticClass:"container"},[_c('Title',[_vm._v(_vm._s(_vm.document.title))]),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.document.text)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }